/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';

export default createSvgIcon(
  <>
    <path
      d="M12 8C14.2091 8 16 6.20914 16 4C16 1.79086 14.2091 0 12 0C9.79086 0 8 1.79086 8 4C8 6.20914 9.79086 8 12 8Z"
      fill="currentColor"
    />
    <path
      d="M4 24C6.20914 24 8 22.2091 8 20C8 17.7909 6.20914 16 4 16C1.79086 16 0 17.7909 0 20C0 22.2091 1.79086 24 4 24Z"
      fill="currentColor"
    />
    <path
      d="M12 8.75C12.4142 8.75 12.75 9.08579 12.75 9.5V13.625L15.95 16.025C16.2814 16.2735 16.3485 16.7436 16.1 17.075C15.8515 17.4064 15.3814 17.4735 15.05 17.225L12 14.9375L8.95 17.225C8.61863 17.4735 8.14853 17.4064 7.9 17.075C7.65147 16.7436 7.71863 16.2735 8.05 16.025L11.25 13.625V9.5C11.25 9.08579 11.5858 8.75 12 8.75Z"
      fill="currentColor"
    />
    <path
      d="M20 24C22.2091 24 24 22.2091 24 20C24 17.7909 22.2091 16 20 16C17.7909 16 16 17.7909 16 20C16 22.2091 17.7909 24 20 24Z"
      fill="currentColor"
    />
  </>,
  'MenuThridPartyFilled'
);
